import { getAccessTokenSilently } from "utils/functions";
import MemberService from "Lib/API/Member";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { withUserExist } from "../CustomHooks";
import EventsCalendar from "../EventsCalendar";

const Events = () => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  const getEventsHandler = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    const orgId = localStorage.getItem("orgId");
    try {
      const eventsRes = await MemberService.getEventsList(token, orgId);
      const calendarEntries = (eventsRes?.payload?.data || []).flatMap((event) => {
        if (event?.multiEvents && event?.multiEventsDates?.length > 0) {
          return event.multiEventsDates.map((dateEntry) => {
            const utcDate = new Date(dateEntry.eventDate);
            const calDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
            const durationMs = (dateEntry?.eventDuration?.value || event?.eventDuration?.value || 60) * 60 * 1000;
            return {
              ...event,
              start: calDate,
              end: new Date(calDate.getTime() + durationMs),
              _utcDate: utcDate,
              title: event?.eventName,
              id: event?._id,
              allDay: false,
            };
          });
        }
        const utcDate = event?.date ? new Date(event.date) : new Date();
        const calDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
        const durationMs = (event?.eventDuration?.value || 60) * 60 * 1000;
        return [{
          ...event,
          start: calDate,
          end: new Date(calDate.getTime() + durationMs),
          _utcDate: utcDate,
          title: event?.eventName,
          id: event?._id,
          allDay: false,
        }];
      });
      setEvents(calendarEntries.sort((a, b) => a.start - b.start || a.title?.localeCompare(b.title)));
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getEventsHandler();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <EventsCalendar events={events} withoutTitle={true} width={"100%"} />
    </div>
  );
};

export default withUserExist(Events);
